import React from "react";
// import ProgatixLogo from '../assets/progatix-logo.svg'

const WidgetFooter = () => {
  return (
    <div
      className="FooterStyle"
      role="region"
      aria-label="footer: Powered By  | CollegePads"
      // aria-label="footer: Powered By  | Progatix"
    >
      {/* <p
        style={{
          marginBottom: "0px",
          border: "none",
          color: "white",
          fontWeight: "400",
          letterSpacing: "0px",
        }}
      >
        {" "}
        Powered By |{" "}
        <a
          style={{
            color: "white",
            border: "none",
            fontWeight: "400",
            letterSpacing: "0px",
            paddingLeft:"10px"
          }}
          target="_blank"
          href="https://www.progatix.com/"
        >
          <img src={'assets/progatix-logo.svg'} alt="progatix logo" width={80} />
        </a>
      </p> */}
    </div>
  );
};

export default WidgetFooter;
